import React, { useContext } from 'react'

const ThemeContext = React.createContext()

const useStyles = (defaultStyles, themes, themeName) => {
  const contextTheme = useContext(ThemeContext),
    theme = themeName || contextTheme

  let styles = defaultStyles

  if (themes && themes[theme]) {
    styles = themes[theme]
  }

  return [styles, theme]
}

export { ThemeContext, useStyles }
export default useStyles
